export enum MILESTONE_TYPE {
  PROGRAM = 'PROGRAM',
  PROJECT = 'PROJECT'
};

export enum MILESTONE_CONTENT_TYPE {
  NOTE = 'NOTE',
  FORM = 'FORM'
}
